import { ModuleConfig } from '@/core/module';
import { savingsProductSettingsRoutes } from './routes';

export const SavingsProductSettingsModule: ModuleConfig = {
    name: 'savings-product-settings',
    routes: savingsProductSettingsRoutes,
    initialize: () => {
        console.log('Savings Product Settings module initialized');
    },
};
